import React, { useState } from 'react';
import { Link } from "react-router-dom";

import './Join2.css';
import loginImg from "../../icons/login.svg";

export default function SignIn() {
  const [name, setName] = useState('');
  const [room, setRoom] = useState('');

  return (
    <div className="base-container">
        <div className="header heading"><h1>JOIN A CHAT</h1></div>
        <div className="content">
          <div className="image">
            <img src={loginImg} alt='logo' />
          </div>
          <div className="form">
            <div className="form-group">
              <label htmlFor="username">NAME</label>
              <input placeholder="Enter your name" className="joinInput" type="text" onChange={(event) => setName(event.target.value)} />
            </div>
            <div className="form-group">
              <label htmlFor="room">ROOM</label>
              <input placeholder="Enter a room no." className="joinInput mt-20" type="text" onChange={(event) => setRoom(event.target.value)} />
            </div>
          </div>
        </div>
        <div className="footer">
        <Link onClick={e => (!name || !room) ? e.preventDefault() : null} to={`/chat?name=${name}&room=${room}`}>
          <button className={'btn'} type="submit">Log In</button>
        </Link>
        </div>
      </div>
  );
}